import React from 'react';
import { VscClose, VscLayoutSidebarLeft, VscLayoutSidebarLeftOff, VscListFlat, VscDatabase, VscSettingsGear, VscCommentDiscussion, VscCalendar, VscFeedback } from 'react-icons/vsc';
import { IoBoat, IoBriefcaseOutline, IoCalendarOutline, IoCalculatorOutline } from 'react-icons/io5';
import { MdCable, MdPrint } from 'react-icons/md';
import { RiUserLine } from 'react-icons/ri';
import { BsFilePdf, BsFileText } from 'react-icons/bs';
import { projectHint } from '../../utils/projectHint';
import './TabBar.css';

const TAB_ICONS = [
  { match: (t) => t.type === 'project-info' || t.id === 'project-new' || t.id.startsWith('project-info-'), Icon: IoBoat,          color: '#4fc1ff' },
  { match: (t) => t.type === 'load-list'    || t.id.startsWith('load-list-'),                              Icon: VscListFlat,     color: '#4ec9b0' },
  { match: (t) => t.type === 'cable-register' || t.id.startsWith('cable-register-'),                      Icon: MdCable,         color: '#ce9178' },
  { match: (t) => ['switchboards','rooms','systems','sections','cable-types','emg-groups'].includes(t.type ?? t.id), Icon: VscDatabase, color: '#9b8ec4' },
  { match: (t) => t.id === 'users' || t.id === 'employee-overview',                                                                        Icon: RiUserLine,      color: '#dcdcaa' },
  { match: (t) => t.id === 'settings' || t.type === 'settings',                                           Icon: VscSettingsGear, color: '#969696' },
  { match: (t) => t.type === 'gantt-diagram' || t.type === 'gantt' || t.id.startsWith('gantt-'),        Icon: VscCalendar,         color: '#98c379' },
  { match: (t) => t.type === 'quote' || t.type === 'quote-summary',                                          Icon: IoCalculatorOutline, color: '#c586c0' },
  { match: (t) => t.type === 'job-packages' || t.type === 'my-job-packages' || t.id.startsWith('job-packages-') || t.id === 'my-job-packages', Icon: IoBriefcaseOutline, color: '#f0a04b' },
  { match: (t) => t.id === 'my-calendar',                                                                 Icon: IoCalendarOutline, color: '#c586c0' },
  { match: (t) => t.type === 'project-calendar' || t.id.startsWith('project-calendar-'),                  Icon: IoCalendarOutline, color: '#4fc1ff' },
  { match: (t) => t.type === 'chat-window',                                                               Icon: VscCommentDiscussion, color: '#56b6c2' },
  { match: (t) => t.id === 'feedback' || t.type === 'feedback',                                           Icon: VscFeedback,     color: '#e06c75' },
  { match: (t) => t.type === 'print-pdf' || t.id.startsWith('print-pdf-'),                                Icon: BsFilePdf,       color: '#f44747' },
  { match: (t) => t.type === 'pdf-viewer',                                                                 Icon: BsFilePdf,       color: '#f44747' },
  { match: (t) => t.type === 'txt-viewer',                                                                 Icon: BsFileText,      color: '#dcdcaa' },
];

function getTabIcon(tab) {
  return TAB_ICONS.find(t => t.match(tab)) || null;
}

function TabBar({ tabs, activeTab, previewTabId, onSelectTab, onCloseTab, onToggleSidePanel, sidePanelOpen }) {
  const activeLabel = tabs.find(t => t.id === activeTab)?.label || '';
  return (
    <div className="tab-bar">
      <button className="tab-bar-toggle" onClick={onToggleSidePanel}
        title={sidePanelOpen ? 'Hide Side Panel' : 'Show Side Panel'}>
        {sidePanelOpen ? <VscLayoutSidebarLeft size={16} /> : <VscLayoutSidebarLeftOff size={16} />}
      </button>
      <span className="tab-bar-mobile-title">{activeLabel}</span>
      <div className="tab-list">
        {tabs.map((tab) => {
          const isPreview = tab.preview === true;
          const ti = getTabIcon(tab);
          return (
            <div key={tab.id}
              className={`tab${activeTab === tab.id ? ' active' : ''}${isPreview ? ' preview' : ''}`}
              onClick={() => onSelectTab(tab.id)}>
              {ti ? <ti.Icon size={14} style={{ color: ti.color, flexShrink: 0 }} /> : null}
              <div className="tab-text">
                <span className="tab-label">{tab.label}</span>
                {projectHint(tab.project) && <span className="tab-project-no">{projectHint(tab.project)}</span>}
              </div>
              <button className="tab-close" onClick={(e) => { e.stopPropagation(); onCloseTab(tab.id); }} title="Close">
                <VscClose size={14} />
              </button>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default TabBar;
